import { useState, useCallback } from 'react';

import DashboardVideos from './Dashboard-video.js';
import Novasenha from './NovaSenha.js';


import logo from '../../../../styles/imagem/Logomarca Cooperval-05.png'
import styled from "styled-components";
import { ImExit } from "react-icons/im";
import { FaVideo } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import GlobalStyle from "../../../../styles/global-portal.js";
import fundo from "../../../../styles/fundo.svg";
import fundo2 from "../../../../styles/fundo2.svg";
import { RiLockPasswordFill } from "react-icons/ri";


const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  min-height: 100vh;
  gap: 15px;
  overflow-y: auto; // Added to ensure scrolling

  @media (max-width: 1024px) {
    width: 100%;
    padding: 10% 0px;
  }

  @media (max-width: 760px) {
    width: 100%;
    padding: 15% 0px;
  }
`;


const BackgroundImage = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;

  @media (max-width: 480px) {
    display: none;
  };

  

`;





const Button = styled.button`
  width: 200px; // Reduced from 250px
  max-width: 80vw; // Adjusted for smaller screens
  height: 70px; // Reduced from 90px
  padding: 10px 20px;
  font-size: 20px; // Slightly smaller default font
  cursor: pointer;
  color: white;
  background-image: url(${fundo});
  border: none;
  border-radius: 10px;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, background 0.3s, border 0.3s; // Added transition for smoothness

  &:hover {
    border: 2px solid #ccc; // Fixed margin to border
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    width: 70vw; // Reduced from 80vw
    height: 60px; // Reduced height
    font-size: 18px; // Adjusted font size
  }

  @media (max-width: 480px) {
    width: 80vw; // Reduced from 90vw
    height: 50px; // Further reduced height
    font-size: 16px; // Smaller font for very small screens
  }
`;

const TopBar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem;
  width: 100%;

  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;

  @media (max-width: 768px) {
    position: relative;
    justify-content: center;
    padding-top: 2rem;
    flex-wrap: wrap;
  }
`;




const ButtonSide1 = styled.button`
  cursor: pointer;
  border: none;
  background-color: transparent;
  color: black;
  font-size: 26px;
`;



const ButtonContainer = styled.div`
  display: flex;
  justify-content: start; 
`;

const ButtonClose = styled.button`
  cursor: pointer;
  border: none;
  background-color: transparent;
  transition: transform 1.5s;
  &:hover {
    transform: scale(1.5);
  }
`;



const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  @media (max-width: 1024px) {
    width: 100%;
    height: 100%;
  }
  

  
`;
const ModalContent = styled.div`
  background-image: url(${fundo2});
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  max-height: 90vh; 
  overflow-y: auto; 

  

`;

const Div3 = styled.div`
  @media (max-width: 768px) {
    margin-top: 20px; // Reduced from 50px
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center; // centraliza os botões
  gap: 15px;
  z-index: 1;
  margin-top: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
  }
`;


const Grid = ({ urlApi, acessos }) => {

  const id = localStorage.getItem('id');
  const token = localStorage.getItem('token');
  //-------------------------------BOTÔES-----------------------------------------------//

  const handleExit = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('id');
    localStorage.removeItem('usuario');

    window.location.href = `/login/`;
  };

  //------------------------------MODAL APRESENTAÇÂO------------------------------------------------//

  //Modal que mostra as apresentações
  const [isModalOpenVideo, setIsModalOpenVideo] = useState(false);
  const modalVideo = () => {
    setIsModalOpenVideo(!isModalOpenVideo);
  };

  //------------------------------MODAL SENHA------------------------------------------------//

  //Modal que mostra as apresentações
  const [isModalOpenSenha, setIsModalOpenSenha] = useState(false);
  const modalSenha = () => {
    setIsModalOpenSenha(!isModalOpenSenha);
  };







  const botoes = [
    { label: 'Gestão', path: '/gestao/', modulo: 1, tipo: 'usuario' },
    { label: 'Boletins Web', path: '/boletim-agricola/', modulo: 2, tipo: 'usuario' },
    { label: 'Boletins Biomassa', path: '/boletim-biomassa/', modulo: 11, tipo: 'usuario' },
    { label: 'Painel de Monitoramento', path: '/painel-de-monitoramento/', modulo: 3, tipo: 'usuario' },
    { label: 'Treinamentos', path: '/treinamento/', modulo: 4, tipo: 'usuario' },
    { label: 'Planejamento Entressafra', path: '/planejamento-entressafra/', modulo: 5, tipo: 'usuario' },
    { label: 'Controle de Reagentes', path: '/controle-reagentes/', modulo: 6, tipo: 'usuario' },
    { label: 'Ordem de Serviço da Oficina', path: '/ordem-servico-oficina/', modulo: 7, tipo: 'usuario' },
    { label: 'Central da TI', path: '/central-ti/', modulo: 8, tipo: 'usuario' },
    { label: 'Aceitação CDC', path: '/aceitacao-cdc/', modulo: 9, tipo: 'usuario' },
    { label: 'Simulador de Cenários', path: 'https://gestao.cooperval.coop.br/', modulo: 10, tipo: 'usuario' },
    { label: 'Gerenciar Usuários', path: '/cadastro-usuarios/', modulo: 0, tipo: 'admin' },

  ];

  const temPermissao = (modulo, tipo = 'usuario') => {
    const acesso = acessos.find((a) => a.COD_MODULO === modulo);
    const regras = {
      usuario: ['A', 'G', 'U', 'S'],
      gestor: ['A', 'G'],
      admin: ['A'],
    };
    return acesso && regras[tipo]?.includes(acesso.TIPO_ACESSO);
  };


  const agruparEmLinhas = (lista, tamanho = 4) => {
    const linhas = [];
    for (let i = 0; i < lista.length; i += tamanho) {
      linhas.push(lista.slice(i, i + tamanho));
    }
    return linhas;
  };


  const logEvento = useCallback(async (id, descricao) => {
    try {
      const logData = {
        COD_FUNCIONARIO: id,
        DESC_LOG: descricao,
      };

      await fetch(`${urlApi}logon/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(logData),
      });
    } catch (error) {
      console.error('Erro ao salvar log:', error);
    }
  }, [urlApi]);




  const navigateTo = async (path, id) => {
    await logEvento(id, `Usuário acessou: ${path}`);
    window.location.href = path;
  };



  return (
    <>
      {isModalOpenVideo && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => {
                modalVideo();
              }}>
                <IoClose color={"red"} size={25} />
              </ButtonClose>
            </ButtonContainer>
            <DashboardVideos urlApi={urlApi} />
          </ModalContent>
        </ModalContainer>
      )}
      {isModalOpenSenha && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => {
                modalSenha();
              }}>
                <IoClose color={"red"} size={25} />
              </ButtonClose>
            </ButtonContainer>
            <Novasenha urlApi={urlApi} acessos={acessos} modalSenha={modalSenha} />
          </ModalContent>
        </ModalContainer>
      )}
      <Container>
        <TopBar>
          <ButtonSide1 onClick={modalVideo} title="Apresentação">
            <FaVideo />
          </ButtonSide1>
          <ButtonSide1 onClick={modalSenha} title="Trocar minha senha">
            <RiLockPasswordFill />
          </ButtonSide1>
          <ButtonSide1 onClick={handleExit} title="Sair">
            <ImExit />
          </ButtonSide1>

        </TopBar>



        <BackgroundImage src={logo} style={{ width: '300px', height: '70px', padding: '0px 20px 20px 0px' }} alt="Logo" />
        <Div3>
          {agruparEmLinhas(botoes.filter(b => temPermissao(b.modulo, b.tipo))).map((linha, i) => (
            <>
              <ContentWrapper key={i}>
                {linha.map((btn, j) => (
                  <Button key={j} onClick={() => navigateTo(btn.path, id)}>
                    {btn.label}
                  </Button>
                ))}

              </ContentWrapper>

            </>
          ))}
        </Div3>


      </Container >
      <GlobalStyle />
    </>

  );
};

export default Grid;
